// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pilot-unemployed__carousel .has-shadow{box-shadow:none}.pilot-unemployed__carousel .carousel-slide{display:flex;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
